import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import GeneWithRefGenomeLink from "../../../../common/helpers/GeneWithRefGenomeLink";
import {
  getVarsomeHost,
  getVariantResultGenes,
} from "../../../../state/selectors/general.selectors";
import variantGeneResolver from "./variantGeneResolver";
import HelperTextLabel from "../../../../components/atoms/HelperText/HelperTextLabel";

const { string, arrayOf, shape } = PropTypes;

const GeneSymbols = ({ variantResultGenes, varsomeHost }) => {
  const [clinicalPortalGenes, setClinicalPortalGenes] = useState([]);
  const { availablesGenes$ } = variantGeneResolver;
  useEffect(() => {
    const subscription = availablesGenes$.subscribe((variantGenes) => {
      setClinicalPortalGenes(variantGenes);
    });
    return () => {
      subscription.unsubscribe();
    };
  }, []);
  const genes = __IS_COMPONENTS_PORTAL__
    ? clinicalPortalGenes
    : variantResultGenes;
  if (genes && genes.length > 0) {
    return (
      <div className="varsome-horiz-list-item">
        <HelperTextLabel
          label={`Gene symbol${genes.length === 1 ? "" : "s"}`}
          fieldDescriptionKey="Gene symbol"
        />
        <div className="varsome-horiz-list-value">
          {genes.map((gene) => {
            return (
              <div key={gene.symbol}>
                <GeneWithRefGenomeLink
                  href={`${varsomeHost}/gene/${gene.symbol}`}
                >
                  {gene.symbol}
                </GeneWithRefGenomeLink>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
  return null;
};

GeneSymbols.propTypes = {
  variantResultGenes: arrayOf(
    shape({
      symbol: string,
    })
  ),
  varsomeHost: string,
};

GeneSymbols.defaultProps = {
  variantResultGenes: null,
  varsomeHost: null,
};

const mapStateToProps = (state) => ({
  varsomeHost: getVarsomeHost(state),
  variantResultGenes: getVariantResultGenes(state),
});

export default connect(mapStateToProps)(GeneSymbols);
